import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/dashboard/Sidebar.jsx';
import DashboardHeader from '../components/dashboard/DashboardHeader.jsx';
import { MARKETER_NAV } from '../constants/navigation.js';

export default function MarketerLayout() {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div className="flex min-h-screen flex-col">
      <DashboardHeader title="Marketer" onMenuClick={() => setNavOpen(true)} />
      <div className="flex flex-1">
        <Sidebar
          items={MARKETER_NAV}
          open={navOpen}
          onClose={() => setNavOpen(false)}
        />
        <main className="min-w-0 flex-1 bg-slate-50 p-4 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
